export default "__VITE_ASSET__NGx1Ewor__"